import './widget.scss';
import quote from '../../assets/img/icons/quote.svg';
import devina from '../../assets/img/devina2.png';

function Quote() {
  return (
    <div className="widget widget--grey">
      <img className="widget__quote" src={quote} alt="Quote" />
      <p className="widget__quote-text">
        We were out in the cold, waiting for the bus when I got a call from The Salvation Army.
      </p>
      <img className="widget__quote-profile-image" src={devina} alt="Devina" />
      <p className="uppercase">Devina</p>
    </div>
  );
}

export default Quote;
